import { type ReactNode } from 'react';
import { Button, Icon } from '@ics-portal/guardian';
import clsx from 'clsx';
import s from '../SummaryCards.module.scss';

export interface SummaryCardContentProps {
    to: string;
    content?: string | ReactNode;
    footer?: string | ReactNode;
    footerClassName?: string;
    navigationLabel?: string;
}

export function SummaryCardContent(props: SummaryCardContentProps): ReactNode {
    const {
        content,
        footer,
        footerClassName: footerClassNameProps,
        navigationLabel,
        to,
    } = props;
    const footerClassName = clsx(
        'flex',
        'pr-1 pb-1',
        footer ? 'justify-content-between' : 'justify-content-end',
        footerClassNameProps,
    );

    return (
        <div className={s.content}>
            {content}
            <div className={footerClassName}>
                {footer ? (
                    <div className="flex align-items-center w-full">
                        {footer}
                    </div>
                ) : null}
                <Button
                    className={s.moreButton}
                    label={navigationLabel || 'View'}
                    link
                    icon={<Icon name="arrow_right_alt" />}
                    iconPos="right"
                    iconSize="sm"
                    to={to}
                />
            </div>
        </div>
    );
}
